module.exports = __webpack_public_path__ + "img/preview.e26d57ab.svg";